<template>
  <div class="error-page">
    <div class="main-wrapper">
      <div class="error-box">
        <h1>500</h1>
        <h3 class="h2 mb-3">Oops! Something went wrong!</h3>
        <p class="h4 font-weight-normal">We're experiencing some technical difficulties. Please try again later.</p>
        <router-link to="/app/dashboard" class="btn btn-primary">
          Back to Dashboard
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error500Page'
}
</script>

<style scoped>
.error-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
}

.error-box {
  text-align: center;
  padding: 40px;
}

.error-box h1 {
  font-size: 120px;
  font-weight: 700;
  color: #dc3545;
  margin-bottom: 20px;
}

.error-box h3 {
  font-weight: 600;
}

.error-box p {
  color: #6c757d;
  margin-bottom: 30px;
}
</style>
